<script setup>

import {useRouter} from "vue-router";

const router = useRouter()

const handleJump = () => {
  router.push({path:'/', query: {anchor: 'gift'}})
}

</script>

<template>
  <img class="gift_icon" src="@/assets/newPc/gift_entry.png" alt="" @click="handleJump">
</template>

<style scoped lang="scss">
.gift_icon {
  width: 9.0625vw;
  height: 6.171875vw;
}
</style>